import { render } from "./Mortgage.vue?vue&type=template&id=0acbba0d"
import script from "./Mortgage.vue?vue&type=script&lang=js"
export * from "./Mortgage.vue?vue&type=script&lang=js"

import "./Mortgage.vue?vue&type=style&index=0&id=0acbba0d&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__